import { LocationQueryValue } from "vue-router";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";

export const additionalQueryParameters = [
  "ExpandedFilters",
  "CollapsedFilters",
  "Layout",
];

export enum SearchPageLayouts {
  boxes = "boxes",
  table = "table",
}

export enum SearchPageEntities {
  Applications = "Applications",
  Certifications = "Certifications",
  Disbursements = "Disbursements",
  Loans = "Loans",
}

export const validPageSizes = [30, 60, 90];

export enum FilterTypes {
  Radio = 1,
  Checkbox = 2,
  Select = 3,
}

export class FilterTypesIds {
  public static get Radio(): number {
    return FilterTypes.Radio;
  }
  public static get Checkbox(): number {
    return FilterTypes.Checkbox;
  }
  public static get Select(): number {
    return FilterTypes.Select;
  }
}

export class FilterTypeNames {
  public static get Radio(): string {
    return FilterTypes[FilterTypes.Radio].toLowerCase();
  }
  public static get Checkbox(): string {
    return FilterTypes[FilterTypes.Checkbox].toLowerCase();
  }
  public static get Select(): string {
    return FilterTypes[FilterTypes.Select].toLowerCase();
  }
}

export interface Page {
  index: number;
  size: number;
  offset?: number;
}

export interface PagedResponse {
  page: Page;
  totalCount: number;
  items: CertificationSearchResultModel[] | DisbursementSearchResultModel[];
}

export interface SearchPageModule {
  loading: boolean;
  error: boolean;
  pageName: string;
  entity: string;
  applications: any[];
  certifications: CertificationSearchResultModel[];
  disbursements: DisbursementSearchResultModel[];
  loans: any[];
  dataDropdown: any[] | boolean;
  dropdownData: boolean;
  filterDisplay: boolean;
  filterOrder: number;
  filters: FilterDefinition[];
  layout: string;
  modal: boolean;
  recentlyViewed: boolean;
  search: {
    text: string | LocationQueryValue[];
    type: string;
    typing?: string | LocationQueryValue[] | null;
    timestamp: number;
    active: boolean;
    focus: boolean;
    error: boolean;
    dropdown: boolean;
  };
  searchResults: {
    error: boolean;
    errorMessage: string;
    data: any[];
  };
  query: {
    pageNumber: number | boolean;
    pageTotal: number;
    totalCount: number;
  };
}

export interface SearchPageProperties {
  data: any[] | string;
  dataDropdown: any[] | boolean;
  dropdownData: boolean;
  filterDisplay: boolean;
  filterOrder: number;
  filters: any[];
  layout: string;
  modal: boolean;
  recentlyViewed: boolean;
  search: {
    text: string | LocationQueryValue[];
    type: string;
    typing: string | LocationQueryValue[];
    timestamp: number;
    active: boolean;
    focus: boolean;
    error: boolean;
    dropdown: boolean;
  };
  query: {
    pageNumber: number | boolean;
    pageTotal: number;
    totalCount: number;
  };
}

export interface FilterDefinition {
  description: string;
  collapsed: boolean;
  filterTypeId: number;
  filterTypeName: string;
  label: string;
  name: string;
  queryParameter: string;
  options: FilterOption[];
  maxVisibleOptions: number | null;
  search: string;
  allowFilterOptionSearch: boolean;
  filterCategoryId: number;
}

export interface FilterOption {
  checked: boolean;
  id: number | string;
  name: string;
  label?: string;
  // frontend fields
  internalOnly: boolean;
  children: any;
}

export interface SortOption {
  property: string;
  descending: boolean;
}

export interface RecentlyViewedItem {
  borrowerInitials?: string; // Cert & Disb
  borrowerName?: string; // Cert & Disb
  firstName?: string; // Application
  lastName?: string; // Application
  category: string;
  id: number | string;
  lenderId?: number; // Application
  lenderName: string;
  name: string; // Application
  page: string;
  timestamp: number;
}

export interface SearchAndFilterRequest {
  search?: string | null;
  page?: Page | null;
  sortOptions: SortOption[];
  filters: FilterDefinition[];
}
